"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogLayout = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A wrapper for `Dialog` content.
 *
 * @related [`Dialog`]
 * @since 8.60.0
 */
var DialogLayout = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "DialogLayout",
  componentId: "c11n-8-107-0__sc-12q10c7-0"
})([""]);
exports.DialogLayout = DialogLayout;
DialogLayout.displayName = 'DialogLayout';

/** @component */